import request from "@/utils/request";

// 门店搜索
export function searchShop(params) {
  const data = params;
  return request({
    url: "/skateboard/system/shop/search",
    method: "post",
    data,
  });
}

// 小程序门店搜索
export function miniSearchShop(params) {
  const data = params;
  return request({
    url: "/skateboard/mini/shop/search",
    method: "post",
    data,
  });
}


// 门店状态设置 启用、禁用
export function setShopStatus(params) {
  const { shopId, status } = params;
  const data = {
    shopId,
    status,
  };
  return request({
    url: "/skateboard/system/shop/set-status",
    method: "post",
    data,
  });
}

// 门店保存
export function addShop(params) {
  const data = params;
  return request({
    url: "/skateboard/system/shop",
    method: "post",
    data,
  });
}

// 门店更新
export function updateShop(params) {
  const data = params;
  return request({
    url: "/skateboard/system/shop/" + params.shop.shopId,
    method: "put",
    data,
  });
}

// 门店删除
export function deleteShop(shopId) {
  return request({
    url: "/skateboard/system/shop/" + shopId,
    method: "delete",
  });
}

// 门店列表（有权限的）
export function accessShops(params) {
  return request({
    url: "/skateboard/system/access-shops",
    method: "post",
    data: params,
  });
}

// 门店等级-搜索
export function shopLevelList(params) {
  return request({
    url: "/skateboard/shop/course-level/search",
    method: "post",
    data: params,
  });
}

// 门店等级-保存
export function addShopLevel(params) {
  return request({
    url: "/skateboard/shop/course-level",
    method: "post",
    data: params,
  });
}

// 门店等级-更新
export function updateShopLevel(params) {
  return request({
    url: "/skateboard/shop/course-level/" + params.id,
    method: "put",
    data: params,
  });
}

// 门店等级-删除
export function deleteShopLevel(params) {
  return request({
    url: "/skateboard/shop/course-level/" + params.id,
    method: "delete",
  });
}

// 门店等级-详情
export function shopLevelDetail(params) {
  return request({
    url: "/skateboard/shop/course-level/" + params.id,
    method: "get",
  });
}

// 科目-搜索
export function shopCourseList(params) {
  return request({
    url: "/skateboard/shop/course/search",
    method: "post",
    data: params,
  });
}

// 科目-批量更新
export function batchUpdateShopCourse(params) {
  return request({
    url: "/skateboard/shop/course/batch-update",
    method: "post",
    data: params,
  });
}

// 科目-保存
export function addShopCourse(params) {
  return request({
    url: "/skateboard/shop/course",
    method: "post",
    data: params,
  });
}

// 科目-更新
export function updateShopCourse(params) {
  return request({
    url: "/skateboard/shop/course/" + params.id,
    method: "put",
    data: params,
  });
}

// 科目-删除
export function deleteShopCourse(params) {
  return request({
    url: "/skateboard/shop/course/" + params.id,
    method: "delete",
  });
}

// 场地-搜索
export function searchPlace(params) {
  return request({
    url: "/skateboard/place/search",
    method: "post",
    data: params,
  });
}
